<template>
  <div class="menuThree">
    <breadCrumb></breadCrumb>
    <base-table :tableData="tableData" ></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    > </pagination>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination"
import baseTable from "../../../../components/baseTable";
import breadCrumb from "../../../../components/breadCrumb";
import { permissionPage } from "../../../../api/admin"
export default {
  name: "menuThird",
  components: {
    baseTable,
    pagination,
    breadCrumb
  },
  data() {
    return {
      paginationDataProduct: {
          total: 0,
          currentPage: 1,
          pageSize: 10
        },
      tableData:{
          tableHeader:[{
            prop:'id',
            label:'菜单ID',
          },{
            prop:'name',
            label:'菜单名称',
          },{
            prop:'permissionLevel',
            label:'层级',
          },{
            prop:'createTime',
            label:'创建时间',
          },{
            prop:'createMan',
            label:'创建人',
          },],
          tableList:[],
          tableType:0,
        }
    };
  },
  created(){
      
      
      this.permissionPage(this.$route.query)
  },
  methods:{
    paginationChangeProduct(val){
        
        this.paginationDataProduct = val
        this.permissionPage(this.$route.query)
      },
    permissionPage(val){
        let vm = this
        permissionPage({
            page:this.paginationDataProduct.currentPage,
            pageSize:this.paginationDataProduct.pageSize,
            permissionLevel: 3,
            pid: val.id,
            permissionType: val.permissionType
        })
        .then(res => {
            
            
            vm.paginationDataProduct.total = res.totalCount
            vm.paginationDataProduct.currentPage = res.pageNo
            vm.paginationDataProduct.pageSize = res.pageSize
            vm.tableData.tableList.splice(0,vm.tableData.tableList.length)
            res.data.map(item => {
                vm.tableData.tableList.push(item)
            })
        })
    }
  }
};
</script>

<style lang="scss" scoped>

</style>